import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'

import styles from './RowAction.module.scss'

interface IRowActionProps {
  text: string
  market?: string
  color?: 'danger' | 'primary'
  isDisabled: boolean
  action: () => void
}

export const RowAction: FC<IRowActionProps> = ({
  text,
  market,
  color = 'primary',
  isDisabled,
  action,
}) => (
  <Button
    variant="text"
    color={color}
    className={styles.root}
    disabled={isDisabled}
    onClick={action}
  >
    <Translation
      text={text}
      replaceParams={
        market
          ? [
              {
                value: market,
                key: '{market}',
              },
            ]
          : undefined
      }
    />
  </Button>
)

RowAction.displayName = 'RowAction'
